export const BORDERED_LABEL_VARIANT = 'bordered';
